import type { IDepositFormUserData } from "../Deposit/Deposit.t";
import { getLocalStorageItem } from "../../utils/storage/getLocalStorageItem";
import { IPaymentFormField } from "./payment.t";

export const calcNewAmountOnIncrement = (currentAmount: number | string, isIncrease: boolean) => {
    let amount = typeof currentAmount === 'number' ? currentAmount : parseFloat(currentAmount);
    let increment, exponent = 0;

    if (isIncrease) {
        if (amount < 10) {
            increment = 1;
        } else {
            while (amount >= 100) {
                amount /= 10;
                exponent++;
            }
            increment = amount >= 50 ? 10 : 5;
        }
    } else {
        if (amount === 0) {
            return amount;
        }
        if (amount <= 10) {
            increment = 1;
        } else {
            while (amount > 100) {
                amount /= 10;
                exponent++;
            }
            increment = amount <= 50 ? 5 : 10;
        }
    }

    const isAmountInt = amount % increment === 0;
    if (isAmountInt) {
        amount = isIncrease ? amount + increment : amount - increment;
    } else {
        amount = Math.floor(amount / increment) * increment;
        if (isIncrease) {
            amount = amount + increment;
        }
    }

    amount = amount * Math.pow(10, exponent);

    return amount;
}

export const roundDepositPreset = (preset: number) => {
    if (preset < 10) {
        return Math.ceil(preset);
    } else if (preset <= 100) {
        return Math.ceil(preset / 5) * 5;
    } else if (preset <= 1000) {
        return Math.ceil(preset / 10) * 10;
    } else if (preset <= 10000) {
        return Math.ceil(preset / 100) * 100;
    } else if (preset <= 100000) {
        return Math.ceil(preset / 1000) * 1000;
    } else {
        return Math.ceil(preset / 10000) * 10000;
    }
}

interface IGetFormDataFieldNewValueProps {
    accountCode: string,
    formDataItem: IPaymentFormField,
    formUserData?: IDepositFormUserData,
    userEmail: string,
}

export const getFormDataFieldDefaultValue = ({ accountCode, formDataItem, formUserData, userEmail }: IGetFormDataFieldNewValueProps) => {
    const value = formDataItem.value ||
        formUserData?.[formDataItem.field] ||
        getLocalStorageItem(accountCode,`payment_form.${formDataItem.field}`);
    let newValue;
    if (formDataItem.input_mode === 'select') {
        newValue = value || formDataItem.options[0].value;
    } else if (formDataItem.field === 'email') {
        newValue = value || userEmail;
    } else if (value) {
        newValue = value;
    }
    return newValue;
}
